import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'

interface ITrackDownloadFilesMutationParamsPayload {
    fileUuids: string[]
    organizationId: string
    brandSlug: string
}

type ITrackDownloadFilesMutationPayload = Pick<ITrackDownloadFilesMutationParamsPayload, 'fileUuids'>

export class TrackDownloadFilesMutation {
    static async call(api: IApi, { organizationId, brandSlug, ...payload }: ITrackDownloadFilesMutationParamsPayload) {
        return api.post<undefined, ITrackDownloadFilesMutationPayload>(
            `/organization/${organizationId}/brands/${brandSlug}/files/download`,
            payload
        )
    }
}

export const useTrackDownloadFilesMutation = () => {
    const { api, apiParams } = useApiToolbox()

    return useApiMutation({
        mutationFn: (fileUuids: string[]) => TrackDownloadFilesMutation.call(api, { ...apiParams, fileUuids }),
    })
}
